/**
 * Role-based permission helpers.
 *
 * user_type mapping (matches backend /app/backend/constants.py):
 *   0 = God
 *   5 = Admin
 *   6 = Operations
 *
 * Pricing rule: ONLY God (0) and Admin (5) can see costs/prices/variance and
 * add or edit job items. Every other role (Operations, Employee, Contractor,
 * SubContractor) is locked out of pricing UI.
 */

export const USER_TYPES = {
  GOD: 0,
  ADMIN: 5,
  OPERATIONS: 6,
};

export const isOps = (user) => user?.user_type === USER_TYPES.OPERATIONS;

/**
 * True if the user can see prices/costs/variance and add or edit job items.
 * Strictly only God (0) and Admin (5).
 */
export const canSeePrices = (user) =>
  user?.user_type === USER_TYPES.GOD || user?.user_type === USER_TYPES.ADMIN;
